var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDropDownMenu({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 4,
    viewBox: "0 0 12 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3125 1.75C7.3125 1.03906 6.71094 0.4375 6 0.4375C5.26172 0.4375 4.6875 1.03906 4.6875 1.75C4.6875 2.48828 5.26172 3.0625 6 3.0625C6.71094 3.0625 7.3125 2.48828 7.3125 1.75ZM10.5938 0.4375C9.85547 0.4375 9.28125 1.03906 9.28125 1.75C9.28125 2.48828 9.85547 3.0625 10.5938 3.0625C11.3047 3.0625 11.9062 2.48828 11.9062 1.75C11.9062 1.03906 11.3047 0.4375 10.5938 0.4375ZM1.40625 0.4375C0.667969 0.4375 0.09375 1.03906 0.09375 1.75C0.09375 2.48828 0.667969 3.0625 1.40625 3.0625C2.11719 3.0625 2.71875 2.48828 2.71875 1.75C2.71875 1.03906 2.11719 0.4375 1.40625 0.4375Z",
    fill: "#233145"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropDownMenu);
export default __webpack_public_path__ + "static/media/icon-drop-down-menu.2afb006351563378402abb13316f5fc2.svg";
export { ForwardRef as ReactComponent };